import { _ } from 'wgnet-awesomejs';
import BaseDescriptionField from 'registration/js/base/fields/description';

import mobile from 'wgnet-awesomejs/lib/mobile';

import template from 'registration/templates/dark/fields/description.html';

const DescriptionField = BaseDescriptionField.extend({
    name: 'description-field',
    template,
    isMTForm: _.extract('Settings.Registration.gameModificatorIsWot', false),
    afterInitialize() {
        BaseDescriptionField.prototype.afterInitialize.call(this);
        this.$inputWrapper = this.$fieldset.find('.js-input-wrapper');
        this.$input = this.$fieldset.find('input');
        if (!this.isMTForm) {
            this.$input.on('focus', _.bind(this.showDescription, this));
            this.$input.on('blur', _.bind(this.hideDescription, this));
        }
    },
    showDescription(event = {}) {
        if (this.isMTForm) {
            if (!event || event.type !== 'mouseenter') {
                return;
            }
            this.getHintPosition(this.$hint);
            this.$hint.removeClass('hidden');
        } else {
            if (mobile().useMobile) {
                return;
            }

            const st = this.$fieldset.data('error-state');
            const er = this.$fieldset.data('suggested-state');

            if (st || er) {
                return;
            }
            if (this.$input.is(':focus') || this.$input[0] === event.currentTarget) {
                this.$hint.removeClass('hidden');
            }
        }
    },
    hideDescription() {
        if (this.isMTForm) {
            if (!event || event.type !== 'mouseout') {
                return;
            }
            this.$hint.addClass('hidden');
        } else {
            this.$hint.addClass('hidden');
        }
    },
});

export default DescriptionField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/dark/fields/description.js